import { ADMIN_CODE_LIST } from './index';
import { Action } from '../action';
import { AccessCodeInfo } from '@shared/core';

export class AdminCodeListInitAction implements Action {
	readonly type = ADMIN_CODE_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListDestroyAction implements Action {
	readonly type = ADMIN_CODE_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListHydrateAction implements Action {
	readonly type = ADMIN_CODE_LIST.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListHydrateSuccessAction implements Action {
	readonly type = ADMIN_CODE_LIST.HYDRATE_SUCCESS;
	constructor(
		public payload: AccessCodeInfo[],
		public correlationId?: number
	) {}
}

export class AdminCodeListHydrateFailureAction implements Action {
	readonly type = ADMIN_CODE_LIST.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectCodeIndexAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT_CODE_INDEX;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectCodeIndexSuccessAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT_CODE_INDEX_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectCodeIndexFailureAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT_CODE_INDEX_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectFirstnameIndexAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT_FIRSTNAME_INDEX;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectExtraIndexAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT_EXTRA_INDEX;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectLastnameIndexAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT_LASTNAME_INDEX;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class AdminCodeListEnableUpdateAction implements Action {
	readonly type = ADMIN_CODE_LIST.ENABLE_UPDATE;
	constructor(
		public payload: boolean,
		public correlationId?: number
	) {}
}

export class AdminCodeListEnableDeleteAction implements Action {
	readonly type = ADMIN_CODE_LIST.ENABLE_DELETE;
	constructor(
		public payload: boolean,
		public correlationId?: number
	) {}
}

export class AdminCodeListEnableAddAction implements Action {
	readonly type = ADMIN_CODE_LIST.ENABLE_ADD;
	constructor(
		public payload: boolean,
		public correlationId?: number
	) {}
}

export class AdminCodeListEnableIgnoreHeaderAction implements Action {
	readonly type = ADMIN_CODE_LIST.ENABLE_IGNORE_HEADER;
	constructor(
		public payload: boolean,
		public correlationId?: number
	) {}
}

export class AdminCodeListCancelImportAction implements Action {
	readonly type = ADMIN_CODE_LIST.CANCEL_IMPORT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListImportDataSuccessAction implements Action {
	readonly type = ADMIN_CODE_LIST.IMPORT_DATA_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListImportDataFailureAction implements Action {
	readonly type = ADMIN_CODE_LIST.IMPORT_DATA_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminCodeListImportDataAction implements Action {
	readonly type = ADMIN_CODE_LIST.IMPORT_DATA;
	constructor(
		public payload: AccessCodeInfo[],
		public correlationId?: number
	) {}
}

export class AdminCodeListDeleteAction implements Action {
	readonly type = ADMIN_CODE_LIST.DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListDeleteSuccessAction implements Action {
	readonly type = ADMIN_CODE_LIST.DELETE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListDeleteFailureAction implements Action {
	readonly type = ADMIN_CODE_LIST.DELETE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminCodeListClickAddAction implements Action {
	readonly type = ADMIN_CODE_LIST.CLICK_ADD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListClickImportAction implements Action {
	readonly type = ADMIN_CODE_LIST.CLICK_IMPORT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListClickEditAction implements Action {
	readonly type = ADMIN_CODE_LIST.CLICK_EDIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListClickDeleteAction implements Action {
	readonly type = ADMIN_CODE_LIST.CLICK_DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT;
	constructor(
		public payload: AccessCodeInfo,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectOrganizationGroupAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT_ORGANIZATION_GROUP;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminCodeListSelectOrganizationAction implements Action {
	readonly type = ADMIN_CODE_LIST.SELECT_ORGANIZATION;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminCodeListClickOrganizationBacklinkAction implements Action {
	readonly type = ADMIN_CODE_LIST.CLICK_ORGANIZATION_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeListClickGroupBacklinkAction implements Action {
	readonly type = ADMIN_CODE_LIST.CLICK_GROUP_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
